export const paywallMixin = {
  computed: {
    isBasePlanValid() {
      return this.basePlan && !this.basePlan.error;
    },
    needLimitations() {
      const companyId = localStorage.getItem('FYGR_COMPANY');
      return (
        !this.subscription.bypass &&
        !(this.subscription.trial && !this.subscription.free_trial_version) &&
        !this.companies[companyId][2] &&
        !this.companies[companyId][3]
      );
    },
    planIncludeReached() {
      return (type) => {
        if (type === 'user') {
          return (
            (this.isBasePlanValid ? this.basePlan?.included_users : 1) +
              this.basePlan?.current_users <=
            this.validUsers.length
          );
        }
        if (type === 'bank') {
          return (
            (this.isBasePlanValid ? this.basePlan?.included_banks : 1) +
              this.basePlan?.current_banks <=
            this.validBanks.length
          );
        }
        if (type === 'integration') {
          return (
            (this.isBasePlanValid
              ? this.basePlan?.included_standard_integrations
              : 1) +
              this.basePlan?.current_standard_integrations <=
            this.validIntegrations.length
          );
        }
        return false;
      };
    },
    planLimitReached() {
      return (type) => {
        if (type === 'scenario') {
          return (
            (this.isBasePlanValid ? this.basePlan?.max_scenarios : 1) <=
            this.scenarios.length
          );
        }
        if (type === 'user') {
          return (
            (this.isBasePlanValid ? this.basePlan?.max_users : 1) <=
            this.validUsers.length
          );
        }
        if (type === 'bank') {
          return (
            (this.isBasePlanValid ? this.basePlan?.max_banks : 1) <=
            this.validBanks.length
          );
        }
        if (type === 'integration') {
          return (
            (this.isBasePlanValid
              ? this.basePlan?.max_standard_integrations
              : 0) <= this.validIntegrations.length
          );
        }
        return false;
      };
    },
    planMax() {
      return (type) => {
        if (type === 'scenario') {
          return this.basePlan?.max_scenarios;
        }
        if (type === 'user') {
          return this.basePlan?.max_users;
        }
        return 1;
      };
    },
    areCustomPermissionsAllowedByPlan() {
      return this.basePlan?.custom_permissions;
    },
    isCompanyV1OrNotTrial() {
      return (
        !this.subscription?.free_trial_version && !this.subscription?.trial
      );
    },
    isCompanyV1NoSubscription() {
      return (
        !this.subscription?.has_subscription &&
        this.subscription?.free_trial_version
      );
    },
  },
  methods: {
    checkLimits(type) {
      if (this.needLimitations && this.planLimitReached(type)) {
        // if (this.basePlan && this.basePlan.plan_family === 'entreprise') {
        //   if (type === 'bank') {
        //     this.isUser = false;
        //     this.customMax = this.basePlan.max_banks;
        //     this.customType = type;
        //   } else {
        //     this.$emit('customMax', {amount: this.planMax(type), type});
        //   }
        //   this.actionSetTooManyConnections(true);
        //   return true;
        // }
        this.basePlan.type = type;
        if (type === 'bank') {
          // called from APP.vue -> need separate logic
          this.showUpgradePopup = true;
        } else {
          this.$emit('unlock', this.basePlan);
        }
        return true;
      }
      if (this.needLimitations && this.planIncludeReached(type)) {
        const plan = {};
        plan.type = type;
        let updateEvent = {};
        let amount = '';
        switch (type) {
          case 'user':
            updateEvent = {users: this.validUsers.length + 1};
            amount = this.basePlan?.additional_user_plan.unit_price;
            break;
          case 'bank':
            updateEvent = {banks: this.validBanks.length + 1};
            amount = this.basePlan?.additional_bank_plan.unit_price;
            break;
          case 'integration':
            updateEvent = {
              standard_integrations: this.validIntegrations.length + 1,
            };
            amount =
              this.basePlan?.additional_standard_integration_plan.unit_price;
            break;
        }
        const toUpdate = {
          ...plan,
          updateEvent,
          amount,
          ...this.basePlan,
        };
        // called from APP.vue -> need separate logic
        if (type === 'bank') {
          this.basePlan = toUpdate;
          this.additionalUpdateData = toUpdate;
        }
        this.$emit('additionalUpdate', toUpdate);

        // if (type === 'user') {
        //   this.$emit('additionalUser', {
        //     ...this.basePlan,
        //     to_add: this.validUsers.length,
        //   });
        // }
        // if (type === 'additionaIntegration') {
        //   this.$emit('additionalIntegration', {
        //     ...this.basePlan,
        //     to_add: this.validUsers.length,
        //   });
        // } else {
        //   this.additionalBank = this.basePlan?.additional_bank_plan.unit_price;
        // }
        return true;
      }
      return false;
    },
  },
};

export default {paywallMixin};
